import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Auto PMA", -1)
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" An amount of ")
const _hoisted_9 = { class: "seq-notice__emphasis-success" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" (+ withholding tax and processing fee) will automatically be deducted from your account every month for your chosen auto PMA products. ")
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "#"),
    /*#__PURE__*/_createVNode("th", null, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Points"),
    /*#__PURE__*/_createVNode("th", { class: "text-end" }, "Member Price"),
    /*#__PURE__*/_createVNode("th", null, "Level"),
    /*#__PURE__*/_createVNode("th", null, "Branch"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4" }, "Action")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", {
  colspan: "7",
  class: "text-center text-muted py-10"
}, "No Auto PMA products found.", -1)
const _hoisted_16 = { class: "ps-4" }
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_20 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_21 = { class: "fw-semibold text-gray-800" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "fw-semibold text-gray-800" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "fw-semibold seq-trend-up" }
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Single", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Double", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Triple", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Branch", -1)
const _hoisted_30 = { class: "pe-4" }
const _hoisted_31 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_32 = {
  key: 4,
  class: "seq-badge seq-badge--pending"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
            ]),
            _hoisted_5
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.divAmount_show == true)
            ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                key: 0,
                variant: "info",
                title: "Monthly deduction",
                class: "mb-6"
              }, {
                default: _withCtx(() => [
                  _createVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("b", _hoisted_9, _toDisplayString(_ctx.numberWithCommas(_ctx.warningAmount.toFixed(2))) + " " + _toDisplayString(_ctx.currency), 1),
                    _hoisted_10
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode("table", _hoisted_12, [
              _hoisted_13,
              _createVNode("tbody", null, [
                (_ctx.list.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_14, [
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: index,
                    class: ["auto-pma-prod-row", { 'seq-row--active': _ctx.selected_prodcode.trim() == item.prodcode.trim() }]
                  }, [
                    _createVNode("td", _hoisted_16, [
                      _createVNode("span", _hoisted_17, _toDisplayString(item.recid), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("span", _hoisted_19, [
                          _createVNode("span", _hoisted_20, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
                          ])
                        ]),
                        _createVNode("div", _hoisted_21, _toDisplayString(item.prodname), 1)
                      ])
                    ]),
                    _createVNode("td", _hoisted_22, [
                      _createVNode("div", _hoisted_23, _toDisplayString(parseFloat(_ctx.pospv_arr[index] * _ctx.autopma_level_selected[index]).toFixed(4)), 1)
                    ]),
                    _createVNode("td", _hoisted_24, [
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.numberWithCommas(parseFloat(_ctx.distPrice_arr[index]).toFixed(2) * parseFloat(_ctx.autopma_level_selected[index]))), 1)
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "seq-table-control seq-table-control--pos",
                        "onUpdate:modelValue": ($event: any) => (_ctx.autopma_level_selected[index] = $event),
                        id: 'autopma_level_' + item.prodcode.trim(),
                        disabled: _ctx.autopma_level_dropdown_disabled_arr[index] == '1',
                        onChange: ($event: any) => (_ctx.computePointsAndPrice(index))
                      }, [
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28
                      ], 40, ["onUpdate:modelValue", "id", "disabled", "onChange"]), [
                        [_vModelSelect, _ctx.autopma_level_selected[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "seq-table-control",
                        "onUpdate:modelValue": ($event: any) => (_ctx.prodreleasebranchcode_selected[index] = $event),
                        disabled: _ctx.autopma_prodreleasebranchcode_dropdown_disabled_arr[index] == '1'
                      }, [
                        _hoisted_29,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branch_arr[index], (item2, index2) => {
                          return (_openBlock(), _createBlock("option", {
                            key: index2,
                            value: item2.branch_code
                          }, _toDisplayString(item2.description), 9, ["value"]))
                        }), 128))
                      ], 8, ["onUpdate:modelValue", "disabled"]), [
                        [_vModelSelect, _ctx.prodreleasebranchcode_selected[index]]
                      ])
                    ]),
                    _createVNode("td", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        (_ctx.selectBtn_arr[index] == '1')
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-seq-blue",
                              disabled: _ctx.selectBtn_disabled_arr[index] == '1',
                              id: 'selectBtn_' + item.prodcode.trim(),
                              title: "Select",
                              onClick: ($event: any) => (_ctx.selectProduct(item.prodcode.trim(), index))
                            }, " Select ", 8, ["disabled", "id", "onClick"]))
                          : _createCommentVNode("", true),
                        ((_ctx.btnsave_show || _ctx.saveBtn_arr[index] == '1') && _ctx.isprocessing[index] === '0')
                          ? (_openBlock(), _createBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-sm btn-seq-green",
                              id: 'saveBtn_' + item.prodcode.trim(),
                              title: "Save",
                              onClick: ($event: any) => (_ctx.saveAutoPMANow(item.prodcode.trim(), index))
                            }, " Save ", 8, ["id", "onClick"]))
                          : _createCommentVNode("", true),
                        ((_ctx.btncancel_show || _ctx.cancelBtn_arr[index] == '1') && _ctx.isprocessing[index] === '0')
                          ? (_openBlock(), _createBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-sm btn-seq-blue",
                              id: 'cancelBtn_' + item.prodcode.trim(),
                              title: "Cancel",
                              onClick: ($event: any) => (_ctx.resetTablePoints(index))
                            }, " Cancel ", 8, ["id", "onClick"]))
                          : _createCommentVNode("", true),
                        ((_ctx.selected_prodcode.trim() == item.prodcode.trim() && _ctx.isprocessing[index] === '0') || _ctx.stopBtn_arr[index] == '1')
                          ? (_openBlock(), _createBlock("button", {
                              key: 3,
                              type: "button",
                              class: "btn btn-sm seq-btn-stop",
                              id: 'stopBtn_' + item.prodcode.trim(),
                              onClick: ($event: any) => (_ctx.stopAutoPMANow(index))
                            }, " Stop Auto PMA ", 8, ["id", "onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.isprocessing[index] === '1')
                          ? (_openBlock(), _createBlock("span", _hoisted_32, "Processing..."))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}